import { render, staticRenderFns } from "./InternalChat.vue?vue&type=template&id=a6f6b612&scoped=true"
import script from "./InternalChat.vue?vue&type=script&lang=js"
export * from "./InternalChat.vue?vue&type=script&lang=js"
import style0 from "./InternalChat.vue?vue&type=style&index=0&id=a6f6b612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f6b612",
  null
  
)

export default component.exports